import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const AppearanceHide14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_15)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M1.53044 0.469666L4.17428 3.11351C7.79714 1.00529 11.3551 3.56514 13.5993 6.54925C13.7993 6.81592 13.7998 7.18333 13.5998 7.45C12.8795 8.40843 12.0166 9.27086 11.0798 10.019L13.5304 12.4697L12.4698 13.5303L9.82575 10.8863C6.2028 12.9948 2.64469 10.435 0.400401 7.45075C0.200402 7.18408 0.200087 6.81634 0.400087 6.54967C1.12051 5.5913 1.98334 4.72887 2.92016 3.98071L0.469776 1.53033L1.53044 0.469666ZM5.27994 4.21917L5.65923 4.59846C8.04057 3.26606 10.6721 6.07014 9.40159 8.34082L10.0115 8.95068C10.7532 8.37739 11.4248 7.71199 12.0332 7C10.3564 5.03779 7.94097 2.87846 5.27994 4.21917ZM8.34095 9.4015L8.7201 9.78065C6.05895 11.1216 3.64339 8.96238 1.96651 7C2.575 6.28791 3.24666 5.62243 3.98853 5.04908L4.59855 5.6591C3.32795 7.92982 5.95957 10.734 8.34095 9.4015ZM5.76248 6.82303C5.64828 7.62888 6.3779 8.35082 7.17702 8.23757L5.76248 6.82303ZM8.23763 7.17686L6.82319 5.76242C7.62896 5.64829 8.3508 6.37782 8.23763 7.17686Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_15'>
        <rect
          width='14'
          height='14'
          fill='white'
          transform='matrix(-1 0 0 1 14 0)'
        />
      </clipPath>
    </defs>
  </Svg>
);

AppearanceHide14.displayName = 'AppearanceHide14';
export default AppearanceHide14;
